/*
 * Copyright (C) 2018 Spanning Cloud Apps. LLC  All rights reserved.
 */
import './kbLink.tpl.html';

(function () {
  /**
   * This directive displays a question mark with a link to a knowledge base article.
   */
  angular
    .module('shared.kbLink', [])
    .directive('sbsfKbLink', directive)
    .controller('KbLinkCtrl', ['$scope', controller]);

  /**
   * Defines the sbsf-kb-link directive.
   *
   * @returns {Object} - The directive settings
   */
  function directive() {
    return {
      controller: 'KbLinkCtrl',
      templateUrl: 'shared/kbLink/kbLink.tpl.html',
      restrict: 'E',
      scope: {
        // The name of the article in https://support.spanning.com/hc/en-us/articles/
        article: '='
      }
    };
  }

  /**
   * The controller for the directive.
   */
  function controller($scope) {}
})();
